// element-ui from表单校验
let elementFromVerify = {
  // 手机号码校验
  checkPass: (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入密码'))
    }
    if (!/^[\w!@#$%^&*]{6,20}$/.test(value)) {
      callback(new Error('请输入6-20位英文字母、数字或者符号(!@#$%^&*_)，或者它们的组合'))
    } else {
      callback()
    }
  },
  /**
 * 价格校验，可带两位小数点
 * @param {Boolean} required 是否必填
 * @param {Boolean} tip 提示标题文本
 */
  picCheck: (required = false, tip = '金额') => {
    return (rule, value, callback) => {
      if (required) {
        if (!value) {
          callback(new Error(`请输入${tip}`))
          return
        }
      } else {
        if (!value) {
          callback()
          return
        }
      }
      if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value)) {
        // 提示：请输入正确的价格:整数或者保留两位小数
        callback(new Error(`请输入正确的${tip}:整数或者保留两位小数`))
      } else {
        callback()
      }
    }
  },
  /**
 * @desc 检验身份证号码
 */
  IdentityCodeValid: (rule, value, callback) => {
    var city = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江 ',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北 ',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏 ',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外 '
    }
    var pass = true

    if (!value || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(value)) {
      callback(new Error('身份证号格式错误,请确认是否输入正确并且不能有空格'))
      pass = false
    } else if (!city[value.substr(0, 2)]) {
      callback(new Error('身份证号地址编码错误,请确认是否输入正确'))
      pass = false
    } else {
      // 18位身份证需要验证最后一位校验位
      if (value.length === 18) {
        value = value.split('')
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        // 校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
        var sum = 0
        var ai = 0
        var wi = 0
        for (var i = 0; i < 17; i++) {
          ai = value[i]
          wi = factor[i]
          sum += ai * wi
        }
        // var last = parity[sum % 11]
        if (parity[sum % 11] !== value[17]) {
          callback(new Error('身份证号校验位错误,请确认是否输入正确'))
          pass = false
        }
      }
    }
    if (pass) callback()
  },
  // 手机号码校验
  phoneValid: (rule, value, callback) => {
    // var telReg = !!value.match(/^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57]|199)[0-9]{8}$/);
    var telReg = !!value.match(/^[0-9]{11}$/)
    // 如果手机号码不能通过验证
    if (telReg === false) {
      callback(new Error('请填写正确的11位数手机号码'))
    } else {
      callback()
    }
  },
  /**
  * @desc 校验Email地址
  * @param {String} val 输入的值
  */
  emailValid: (rule, value, callback) => {
    // var telReg = !!val.match(/^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57]|199)[0-9]{8}$/);
    var telReg = !!value.match(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
    // 如果手机号码不能通过验证
    if (telReg === false) {
      callback(new Error('请填写正确得邮箱地址'))
    } else {
      callback()
    }
  },
  /**
* 姓名校验
* @param {Boolean} required 是否必填
* @param {Boolean} tip 提示标题文本
*/
  nameValid: (required = false, tip = '姓名') => {
    return (rule, value, callback) => {
      if (required) {
        if (!value) {
          callback(new Error(`请输入${tip}`))
          return
        }
      } else {
        if (!value) {
          callback()
          return
        }
      }
      if (!/^(·|[\u4e00-\u9fa5]){2,}$/g.test(value)) {
        callback(new Error(`请输入2个字符以上的纯中文的${tip},并且不能有空格`))
      } else {
        callback()
      }
    }
  },
  // 护照校验
  hzValid: (rule, value, callback) => {
    let hzReg = /^[a-zA-Z0-9]{3,21}$/.test(value)
    if (hzReg === false) {
      callback(new Error('请输入正确的护照格式，并且在3-21位字符以内'))
    } else {
      callback()
    }
  },
  // 军官证校验
  jgValid: (rule, value, callback) => {
    let jgReg = /^[a-zA-Z0-9]{7,21}$/.test(value)
    if (jgReg === false) {
      callback(new Error('请输入正确的军官证格式，并且在7-21位字符以内'))
    } else {
      callback()
    }
  },
  // 港澳台通行证和回乡证校验
  gatValid: (rule, value, callback) => {
    let gaReg = /^[a-zA-Z0-9]{5,21}$/.test(value)
    if (gaReg === false) {
      callback(new Error('请输入正确的港澳台回乡证或台胞证格式，并且在5-21位字符以内'))
    } else {
      callback()
    }
  },
  // 只能输入纯数字
  numberValid: (rule, value, callback) => {
    let gaReg = /^[0-9]{1,}$/.test(value)
    if (gaReg === false) {
      if (!value) {
        callback(new Error('不能为空'))
      } else {
        callback(new Error('只能输入整数，数字'))
      }
    } else {
      callback()
    }
  },
  // 只能输入数字和英文字母
  num_azValid: (rule, value, callback) => {
    let gaReg = /^[a-zA-Z0-9]*$/.test(value)
    if (gaReg === false) {
      callback(new Error('只能输入包含：大小写字母或者数字'))
    } else {
      callback()
    }
  },
  money_Valid: (rule, value, callback) => {
    if (!value && value !== 0) return callback()
    var exp = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/
    if (!exp.test(value)) {
      callback(new Error('请输入正确的金额格式'))
    } else {
      callback()
    }
  },
  // 空检验
  emptyValid: (rule, value, callback) => {
    if (!value || !value.replace(/\s+/g, '')) {
      callback(new Error('不能为空'))
    } else {
      callback()
    }
  }
}

export { elementFromVerify }
